import classnames from 'classnames';
import React from 'react';
import useStyles from './FloatingCard.styles';
const FloatingCard = ({ className, children }) => {
    const classes = useStyles();
    return React.createElement("div", { className: classnames(classes.root, className) }, children);
};
export default FloatingCard;
